<script>
import Layout from '@layouts/main'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import receitaExcelService from '@/src/services/receita-excel'
import produtorRural from '@/src/services/produtor-rural'
import agronomoService from '@/src/services/agronomo'
import viewerReceituario from '@/src/components/modal-viewer-receita.vue'
import empresaService from '@/src/services/empresa_sistema'
import receitaService from '@/src/services/receita'

export default {
  components: {
    Layout,
    Loading,
    viewerReceituario,
  },
  data() {
    return {
      isLoading: false,
      arquivo: null,
      arquivoNome: '',
      previewProdutos: true,
      previewData: null,
      produtores: [],
      agronomos: [],
      produtorSelecionado: null,
      agronomoSelecionado: null,
      receita: {},
      empresaData: {},
      unidadeOptions: ['L', 'KG'],
      produtosFields: [
        { key: 'linha', label: 'Linha' },
        { key: 'codigoSap', label: 'Código SAP' },
        { key: 'quantidadeSolicitada', label: 'Qtd.' },
        { key: 'produto', label: 'Produto' },
        { key: 'cultura', label: 'Cultura' },
        { key: 'alvos', label: 'Alvos' },
        { key: 'avisos', label: 'Avisos' },
      ],
    }
  },
  computed: {
    token() {
      return this.$store.state.auth.currentUser.token
    },
    produtos() {
      return this.previewData && this.previewData.produtos
        ? this.previewData.produtos
        : []
    },
    naoEncontrados() {
      return this.previewData && this.previewData.naoEncontrados
        ? this.previewData.naoEncontrados
        : []
    },
  },
  mounted() {
    this.carregarSeletores()
    this.getEmpresa()
  },
  methods: {
    getEmpresa() {
      empresaService
        .listarEmpresa(this.token)
        .then((response) => {
          this.empresaData =
            response.data && response.data.empresa && response.data.empresa[0]
              ? response.data.empresa[0]
              : {}
        })
        .catch(() => {
          this.empresaData = {}
        })
    },
    async carregarSeletores() {
      this.isLoading = true

      try {
        const [produtoresResponse, agronomosResponse] = await Promise.all([
          produtorRural.listar(this.token, 1, 100),
          agronomoService.listar(this.token),
        ])

        this.produtores = this.extractCollection(produtoresResponse.data, [
          'data',
          'produtores',
          'items',
        ])
        this.agronomos = this.extractCollection(agronomosResponse.data, [
          'data',
          'agronomos',
          'items',
        ])
      } catch (error) {
        this.showToast(this.getErrorMessage(error), 'danger')
      } finally {
        this.isLoading = false
      }
    },
    extractCollection(payload, keys) {
      if (Array.isArray(payload)) {
        return payload
      }

      for (const key of keys) {
        if (payload && Array.isArray(payload[key])) {
          return payload[key]
        }
      }

      if (payload && payload.data && Array.isArray(payload.data.data)) {
        return payload.data.data
      }

      return []
    },
    handleFileChange(event) {
      const [file] = event.target.files || []
      this.processSelectedFile(file)
    },
    handleFileDrop(event) {
      const [file] = event.dataTransfer && event.dataTransfer.files
        ? event.dataTransfer.files
        : []

      this.processSelectedFile(file)
    },
    processSelectedFile(file) {
      this.arquivo = file || null
      this.arquivoNome = file && file.name ? file.name : ''

      if (this.arquivo) {
        this.importarExcel()
      }
    },
    async importarExcel() {
      if (!this.arquivo) {
        this.showToast('Selecione uma planilha Excel para importar.', 'warning')
        return
      }

      this.isLoading = true

      try {
        const response = await receitaExcelService.importarPreviewProdutos(
          this.token,
          this.arquivo,
          this.previewProdutos
        )

        if (response.data && response.data.sucesso === false) {
          this.previewData = null
          this.showToast(
            response.data.aviso && response.data.aviso.mensagem
              ? response.data.aviso.mensagem
              : 'Não foi possível importar a planilha.',
            'warning'
          )
          return
        }

        this.previewData =
          response.data && response.data.data ? response.data.data : response.data || null
        this.prepareProductTargets()

        if (!this.hasProductRelations()) {
          this.showMissingProductRelationsModal()
          return
        }

        await this.calculateInitialApplicationAreas()

        this.showToast(
          response.data && response.data.message
            ? response.data.message
            : 'Prévia de produtos do Excel concluída.',
          'success'
        )
      } catch (error) {
        this.previewData = null
        this.showToast(this.getErrorMessage(error), 'danger')
      } finally {
        this.isLoading = false
      }
    },
    novaImportacao() {
      this.arquivo = null
      this.arquivoNome = ''
      this.previewData = null
      this.produtorSelecionado = null
      this.agronomoSelecionado = null

      if (this.$refs.inputExcel) {
        this.$refs.inputExcel.value = ''
      }
    },
    removeProductItem(item) {
      if (!this.previewData || !Array.isArray(this.previewData.produtos)) {
        return
      }

      this.previewData.produtos = this.previewData.produtos.filter(
        (produto) => produto !== item
      )
    },
    prepareProductTargets() {
      this.produtos.forEach((item) => {
        if (!Object.prototype.hasOwnProperty.call(item, 'alvoSelecionado')) {
          this.$set(
            item,
            'alvoSelecionado',
            item.alvos && item.alvos.length ? item.alvos[0] : null
          )
        }

        if (!Object.prototype.hasOwnProperty.call(item, 'unidadeQuantidade')) {
          this.$set(item, 'unidadeQuantidade', this.getDefaultUnit(item))
        }

        if (!Object.prototype.hasOwnProperty.call(item, 'areaCalculada')) {
          this.$set(item, 'areaCalculada', null)
        }

        if (!Object.prototype.hasOwnProperty.call(item, 'areaMensagem')) {
          this.$set(item, 'areaMensagem', '')
        }

        if (!Object.prototype.hasOwnProperty.call(item, 'areaCalculando')) {
          this.$set(item, 'areaCalculando', false)
        }
      })
    },
    async calculateInitialApplicationAreas() {
      const itemsToCalculate = this.produtos.filter((item) => {
        return item.alvoSelecionado && item.unidadeQuantidade
      })

      await Promise.all(
        itemsToCalculate.map((item) => this.calculateApplicationArea(item, false))
      )
    },
    async gerarReceita() {
      if (!this.produtorSelecionado || !this.agronomoSelecionado) {
        this.showToast(
          'Selecione o produtor e o responsável técnico para continuar.',
          'warning'
        )
        return
      }

      const validationMessage = this.validateProductsForEmission()
      if (validationMessage) {
        this.showToast(validationMessage, 'warning')
        return
      }

      this.isLoading = true

      try {
        await this.calculateAllApplicationAreas()

        const response = await receitaExcelService.emitirReceita(
          this.token,
          this.buildEmissionPayload()
        )

        if (response.data && response.data.sucesso === false) {
          this.showToast(
            response.data.aviso && response.data.aviso.mensagem
              ? response.data.aviso.mensagem
              : 'Não foi possível emitir a receita.',
            'warning'
          )
          return
        }

        this.receita =
          response.data && response.data.receita ? response.data.receita : {}

        this.showToast(
          response.data && response.data.message
            ? response.data.message
            : 'Receituário gerado com sucesso.',
          'success'
        )

        await this.showIssuedRecipe()
      } catch (error) {
        this.showToast(this.getErrorMessage(error), 'danger')
      } finally {
        this.isLoading = false
      }
    },
    async showIssuedRecipe() {
      const receitaId = this.receita && (
        this.receita.idReceita ||
        this.receita.id_receita ||
        this.receita.id
      )

      if (!receitaId) {
        this.$bvModal.show('rel-receita-excel')
        return
      }

      try {
        const response = await receitaService.findById(this.token, receitaId)
        const receitaComplemento =
          response.data && response.data.receita ? response.data.receita : null

        if (receitaComplemento) {
          const agronomo = receitaComplemento.agronomo || {}
          this.receita.assinatura = agronomo.digital_signature
          this.receita.is_sign_produtor = agronomo.is_sign_prod
          this.receita.hash = receitaComplemento.hash
          this.receita.data_hora = receitaComplemento.data_hora
          this.receita.url_pdf = receitaComplemento.url_pdf
        }
      } catch (error) {
        this.showToast(
          'Receituário gerado, mas não foi possível carregar os detalhes completos.',
          'warning'
        )
      }

      this.$bvModal.show('rel-receita-excel')
    },
    validateProductsForEmission() {
      if (!this.produtos.length) {
        return 'Nenhum produto encontrado para emissão.'
      }

      const invalidProduct = this.produtos.find((item) => {
        const produto = item && item.produto ? item.produto : {}
        const cultura = item && item.cultura ? item.cultura : {}
        const alvo = item && item.alvoSelecionado ? item.alvoSelecionado : null
        const quantidade = this.toNumber(item && item.quantidadeSolicitada)

        return (
          !this.getProductId(produto) ||
          !this.getCultureId(cultura) ||
          !this.getTargetId(alvo) ||
          !this.getRelationId(alvo) ||
          !item.unidadeQuantidade ||
          !quantidade ||
          quantidade <= 0
        )
      })

      if (invalidProduct) {
        return `Verifique produto, cultura, alvo, unidade e quantidade na linha ${invalidProduct.linha || '-'}.`
      }

      return ''
    },
    async calculateAllApplicationAreas() {
      for (const item of this.produtos) {
        await this.calculateApplicationArea(item, true)
      }

      const withoutArea = this.produtos.find((item) => {
        return item.areaCalculada === null || item.areaCalculada === undefined
      })

      if (withoutArea) {
        throw new Error(
          `Não foi possível calcular a área da linha ${withoutArea.linha || '-'}.`
        )
      }
    },
    async calculateApplicationArea(item, showError = true) {
      if (!item || !item.alvoSelecionado) {
        return
      }

      this.$set(item, 'areaCalculando', true)
      this.$set(item, 'areaMensagem', 'Calculando área...')

      const payload = this.buildCalculationPayload(item)
      if (!payload) {
        this.$set(item, 'areaCalculando', false)
        this.$set(item, 'areaCalculada', null)
        this.$set(
          item,
          'areaMensagem',
          item.alvoSelecionado
            ? 'Não foi possível identificar a relação do alvo para cálculo.'
            : ''
        )
        return
      }

      try {
        const response = await receitaExcelService.calcularAplicacao(
          this.token,
          payload
        )
        const data = response.data || {}

        if (data.sucesso === false) {
          throw new Error(
            data.aviso && data.aviso.mensagem
              ? data.aviso.mensagem
              : 'Não foi possível calcular a área.'
          )
        }

        const area = Number(data.value)

        this.$set(item, 'areaCalculada', Number.isNaN(area) ? null : area)
        this.$set(
          item,
          'areaMensagem',
          data.message || (
            !Number.isNaN(area) ? `${area} ${data.unit || 'ha'}` : ''
          )
        )
      } catch (error) {
        this.$set(item, 'areaCalculada', null)
        this.$set(item, 'areaMensagem', this.getErrorMessage(error))

        if (showError) {
          throw error
        }
      } finally {
        this.$set(item, 'areaCalculando', false)
      }
    },
    buildCalculationPayload(item) {
      const alvo = item.alvoSelecionado || {}
      const relacao =
        this.getRelationId(alvo) ||
        this.getRelationId(item) ||
        this.getRelationId(item.produto) ||
        this.getTargetId(alvo)
      const quantidade = this.toNumber(item.quantidadeSolicitada)

      if (!relacao || !quantidade || quantidade <= 0) {
        return null
      }

      return {
        relacao,
        numeroAplicacoes: this.toNumber(
          alvo.nAplicacoes || alvo.numeroAplicacoes || 1
        ),
        dose: this.toNumber(alvo.dose || alvo.doseMin || alvo.doseMax || 0),
        quantidade,
        unidadeQuantidade: item.unidadeQuantidade || 'L',
        calda: this.toNumber(alvo.volumeCalda || alvo.calda || 0),
      }
    },
    buildEmissionPayload() {
      const itens = this.produtos.map((item) => this.mapProductForEmission(item))
      const produtor = this.produtorSelecionado
      const responsavelTecnico = this.agronomoSelecionado

      return {
        receita: {
          id_produtor: this.getProducerId(produtor),
          id_agronomo: this.getTechnicianId(responsavelTecnico),
          nf: '',
          serie: '',
          valor: 0,
          itens,
        },
      }
    },
    mapProductForEmission(item) {
      const produto = item.produto || {}
      const cultura = item.cultura || {}
      const alvoSelecionado = item.alvoSelecionado || {}
      const quantidade = this.toNumber(item.quantidadeSolicitada)

      return {
        cod_prod_nf: item.codigoSap,
        id_produto: this.getProductId(produto),
        nome: produto.nome,
        quantidade,
        quantidadeCalculoArea: quantidade,
        quantidadeFormatada: String(item.quantidadeSolicitada),
        id_cultura: this.getCultureId(cultura),
        id_alvo: this.getTargetId(alvoSelecionado),
        unidade: item.unidadeQuantidade || 'L',
        area: item.areaCalculada || item.area,
      }
    },
    getDefaultUnit(item) {
      const produto = item && item.produto ? item.produto : {}
      const unidade = String(
        produto.unidade ||
        produto.unidadeMedida ||
        produto.siglaUnidade ||
        ''
      ).toUpperCase()

      return unidade === 'KG' ? 'KG' : 'L'
    },
    toNumber(value) {
      if (typeof value === 'number') {
        return value
      }

      if (value === null || value === undefined || value === '') {
        return 0
      }

      const normalizedValue = String(value).trim()

      if (normalizedValue.includes(',')) {
        return Number(normalizedValue.replace(/\./g, '').replace(',', '.'))
      }

      return Number(normalizedValue)
    },
    handleTargetChange(item, alvo) {
      if (alvo !== undefined) {
        this.$set(item, 'alvoSelecionado', alvo)
      }

      this.$nextTick(() => this.calculateApplicationArea(item, false))
    },
    handleUnitChange(item) {
      this.$nextTick(() => this.calculateApplicationArea(item, false))
    },
    getProductId(produto) {
      return produto && (produto.idProduto || produto.id_produto || produto.id)
    },
    getCultureId(cultura) {
      return cultura && (cultura.idCultura || cultura.id_cultura || cultura.id)
    },
    getTargetId(alvo) {
      return alvo && (alvo.idAlvo || alvo.id_alvo || alvo.id)
    },
    getRelationId(alvo, depth = 0) {
      if (!alvo) {
        return null
      }

      const explicitRelation = (
        alvo.idItemProduto ||
        alvo.id_item_produto ||
        alvo.id_item_produto_cultura ||
        alvo.id_item_produto_alvo ||
        alvo.idItemProdutoAlvo ||
        alvo.idProdutoCulturaAlvo ||
        alvo.id_produto_cultura_alvo ||
        alvo.idProdutoCultura ||
        alvo.id_produto_cultura ||
        alvo.idProdutoAlvo ||
        alvo.id_produto_alvo ||
        alvo.idRelacao ||
        alvo.id_relacao ||
        alvo.idRelacionamento ||
        alvo.id_relacionamento ||
        alvo.idItem ||
        alvo.id_item ||
        alvo.itemProduto ||
        alvo.item_produto ||
        alvo.relacao
      )

      if (explicitRelation) {
        return explicitRelation
      }

      const relationKey = Object.keys(alvo).find((key) => {
        const normalizedKey = key.toLowerCase()
        const value = alvo[key]

        return (
          value &&
          (typeof value === 'number' || /^[0-9]+$/.test(String(value))) &&
          (
            normalizedKey.includes('relacao') ||
            normalizedKey.includes('relação') ||
            (normalizedKey.includes('item') && normalizedKey.includes('produto')) ||
            (normalizedKey.includes('produto') && normalizedKey.includes('cultura')) ||
            (normalizedKey.includes('produto') && normalizedKey.includes('alvo'))
          )
        )
      })

      if (relationKey) {
        return alvo[relationKey]
      }

      return this.findNestedRelationId(alvo, depth + 1)
    },
    findNestedRelationId(source, depth = 0) {
      if (!source || depth > 2 || typeof source !== 'object') {
        return null
      }

      const nestedKeys = Object.keys(source).filter((key) => {
        const value = source[key]
        return value && typeof value === 'object' && !Array.isArray(value)
      })

      for (const key of nestedKeys) {
        const relation = this.getRelationId(source[key], depth)
        if (relation) {
          return relation
        }
      }

      return null
    },
    getProducerId(produtor) {
      return produtor && (produtor.id_produtor_rural || produtor.idProdutor || produtor.id)
    },
    getTechnicianId(responsavelTecnico) {
      return responsavelTecnico && (
        responsavelTecnico.id_agronomo ||
        responsavelTecnico.idAgronomo ||
        responsavelTecnico.id
      )
    },
    produtoDescricao(item) {
      const produto = item && item.produto ? item.produto : {}
      return [produto.nome, produto.mapa, produto.codErp]
        .filter(Boolean)
        .join(' | ')
    },
    produtoNome(item) {
      return item && item.produto && item.produto.nome
        ? item.produto.nome
        : 'Produto não informado'
    },
    culturaPadraoNome() {
      return this.previewData &&
        this.previewData.culturaPadrao &&
        this.previewData.culturaPadrao.nomeComum
        ? this.previewData.culturaPadrao.nomeComum
        : 'Não informada'
    },
    culturaPadraoCientifico() {
      return this.previewData &&
        this.previewData.culturaPadrao &&
        this.previewData.culturaPadrao.nomeCientifico
        ? this.previewData.culturaPadrao.nomeCientifico
        : ''
    },
    culturaDescricao(item) {
      const cultura = item && item.cultura ? item.cultura : {}
      return [cultura.nomeComum, cultura.nomeCientifico]
        .filter(Boolean)
        .join(' | ')
    },
    formatAlvos(alvos) {
      if (!Array.isArray(alvos) || alvos.length === 0) {
        return 'Sem alvos'
      }

      return alvos
        .map((alvo) => {
          const nome = alvo.nomeComum || alvo.nomeCientifico || 'Alvo'
          const dose = alvo.dose || alvo.doseMin || alvo.doseMax
          return dose ? `${nome} (${dose} ${alvo.unidade || ''})` : nome
        })
        .join(', ')
    },
    alvoLabel(alvo) {
      if (!alvo) {
        return 'Alvo'
      }

      const nome = [alvo.nomeComum, alvo.nomeCientifico]
        .filter(Boolean)
        .join(' | ') || 'Alvo'
      return nome
    },
    hasProductRelations() {
      return this.produtos.some((item) => {
        const cultura = item && item.cultura ? item.cultura : null
        const hasCulture =
          cultura &&
          (cultura.idCultura || cultura.nomeComum || cultura.nomeCientifico)
        const hasTargets =
          item && Array.isArray(item.alvos) && item.alvos.length > 0

        return Boolean(hasCulture && hasTargets)
      })
    },
    showMissingProductRelationsModal() {
      const message =
        'Não foi localizado nenhum produto. Verifique os vínculos dos produtos.'

      if (this.$bvModal && this.$bvModal.msgBoxOk) {
        this.$bvModal.msgBoxOk(message, {
          title: 'Aviso',
          size: 'md',
          buttonSize: 'md',
          okTitle: 'Entendi',
          okVariant: 'success',
          centered: true,
          hideHeaderClose: false,
        })
        return
      }

      this.showToast(message, 'warning')
    },
    getErrorMessage(error) {
      const data = error && error.response ? error.response.data : null

      return (
        (data && data.aviso && data.aviso.mensagem) ||
        (data && data.message) ||
        (data && data.mensagem) ||
        (error && error.message) ||
        'Não foi possível concluir a operação.'
      )
    },
    showToast(message, variant = 'info') {
      this.$bvToast.toast(message, {
        title: 'Receita por Excel',
        variant,
        solid: true,
      })
    },
  },
}
</script>

<template>
  <Layout>
    <loading :active.sync="isLoading" :is-full-page="true" />

    <div class="excel-receita-page bloco">
      <div class="row align-items-start">
        <div class="col-md-7">
          <div class="titulo">
            <i class="uil uil-file-upload-alt"></i>
            Gerar Receita por Excel
          </div>
          <div class="subTitulo">
            Importe a planilha para validar produtos, cultura e alvos antes da
            emissão.
          </div>
        </div>
        <div class="col-md-5">
          <div class="excel-page-actions">
            <button
              v-if="previewData"
              class="btn btn-light"
              type="button"
              @click="novaImportacao"
            >
              <i class="uil uil-redo"></i>
              Nova importação
            </button>
            <button
              v-if="previewData"
              class="btn btn-webreceita"
              type="button"
              @click="gerarReceita"
            >
              <i class="uil uil-check-circle"></i>
              Gerar receita
            </button>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>

      <div v-if="!previewData" class="excel-dashboard">
        <section class="excel-upload-card">
          <div class="upload-content">
            <div
              class="upload-dropzone"
              @dragover.prevent
              @drop.prevent="handleFileDrop"
            >
              <div class="upload-dropzone-copy">
                <i class="uil uil-file-check-alt"></i>
                <div>
                  <strong>
                    {{ arquivoNome || 'Clique ou arraste a planilha Excel aqui' }}
                  </strong>
                  <span>
                    O processamento inicia automaticamente após selecionar o arquivo.
                  </span>
                </div>
              </div>

              <input
                id="excel-upload-input"
                ref="inputExcel"
                type="file"
                class="upload-file-input"
                accept=".xlsx,.xls"
                @change="handleFileChange"
              >
            </div>
          </div>
        </section>
      </div>

      <div v-else class="excel-dashboard">
        <section class="excel-section">
          <div class="section-title">
            <h2>Dados da receita</h2>
            <p>Selecione quem receberá a receita e o responsável técnico.</p>
          </div>

          <div class="excel-form-grid">
            <b-form-group label="Produtor">
              <v-select
                v-model="produtorSelecionado"
                :options="produtores"
                label="nome"
                placeholder="Selecione o produtor"
              />
            </b-form-group>
            <b-form-group label="Responsavel tecnico">
              <v-select
                v-model="agronomoSelecionado"
                :options="agronomos"
                label="nome"
                placeholder="Selecione o responsável técnico"
              />
            </b-form-group>
          </div>
        </section>

        <section class="excel-list-card">
          <div class="excel-list-head">
            <div>
              <h2>Produtos da planilha</h2>
              <p>Confira os produtos retornados pela importação do Excel.</p>
            </div>
          </div>

          <div class="excel-table-wrap">
            <table class="excel-table">
              <thead>
                <tr>
                  <th>Produto</th>
                  <th>Cultura</th>
                  <th>Qtd.</th>
                  <th>Unidade</th>
                  <th>Alvos</th>
                  <th>Área</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in produtos" :key="`${item.linha}-${item.codigoSap}`">
                  <td>
                    <strong>{{ produtoNome(item) }}</strong>
                    <span>{{ produtoDescricao(item) || 'Sem detalhes adicionais' }}</span>
                  </td>
                  <td>{{ culturaDescricao(item) || 'Não informada' }}</td>
                  <td>
                    <strong>{{ item.quantidadeSolicitada }}</strong>
                  </td>
                  <td>
                    <select
                      v-model="item.unidadeQuantidade"
                      class="unit-select"
                      @change="handleUnitChange(item)"
                    >
                      <option
                        v-for="unidade in unidadeOptions"
                        :key="unidade"
                        :value="unidade"
                      >
                        {{ unidade }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <v-select
                      v-if="item.alvos && item.alvos.length"
                      v-model="item.alvoSelecionado"
                      :append-to-body="true"
                      :options="item.alvos"
                      :get-option-label="alvoLabel"
                      class="target-select"
                      placeholder="Selecione o alvo"
                      @input="handleTargetChange(item, $event)"
                      @option:selected="handleTargetChange(item, $event)"
                    />
                    <span v-else>Sem alvos</span>
                  </td>
                  <td>
                    <div class="area-cell">
                      <strong v-if="item.areaCalculando">
                        Calculando...
                      </strong>
                      <strong v-else-if="item.areaCalculada !== null && item.areaCalculada !== undefined">
                        {{ item.areaCalculada }} ha
                      </strong>
                      <span v-else>Área não calculada</span>
                      <small v-if="item.areaMensagem">{{ item.areaMensagem }}</small>
                    </div>
                  </td>
                  <td>
                    <button
                      v-b-tooltip.hover
                      class="btn-remove-item"
                      title="Remover item"
                      type="button"
                      @click="removeProductItem(item)"
                    >
                      <i class="uil uil-trash-alt"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="!produtos.length">
                  <td colspan="7" class="excel-empty">
                    Nenhum produto encontrado na planilha.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>

    <viewerReceituario
      id="rel-receita-excel"
      :receita="receita"
      :empresa="empresaData"
      :isSignature="empresaData.is_digital_signature"
    />
  </Layout>
</template>

<style lang="scss" scoped>
.excel-receita-page.bloco {
  background-color: #fff;
  border: 1px solid #e3e8ef;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.05);
  margin-top: 24px;
  padding: 32px;

  .titulo {
    align-items: center;
    color: #008e75;
    display: flex;
    font-size: 25px;
    font-weight: bold;
    gap: 8px;
    margin-bottom: 10px;
  }

  .subTitulo {
    color: #354158;
    margin-bottom: 10px;
  }

  .borda {
    border-bottom: solid 1px #edeff4;
    margin: 15px 0;
  }

  .btn-webreceita {
    background-color: #008e75;
    border-color: #008e75;
    color: #fff;
    padding: 9px 24px;
  }
}

.excel-page-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;

  .btn {
    align-items: center;
    border-radius: 5px;
    display: inline-flex;
    font-weight: 600;
    gap: 7px;
    height: 42px;
    justify-content: center;
    margin: 0;
    min-width: 150px;
    padding: 0 18px;
  }

  .btn-light {
    background: #fff;
    border-color: #d8dee8;
    color: #172033;
  }
}

.excel-dashboard {
  background: #f5f7fb;
  border-radius: 8px;
  display: grid;
  gap: 18px;
  padding: 2px 0 0;
}

.excel-upload-card,
.excel-section,
.excel-list-card {
  background: #fff;
  border: 1px solid #dfe6ef;
  border-radius: 7px;
}

.excel-upload-card {
  padding: 24px;
}

.upload-content {
  display: block;
}

.upload-dropzone {
  align-items: center;
  background: #fbfcfe;
  border: 1px dashed #b9c7d8;
  border-radius: 8px;
  cursor: pointer;
  display: block;
  min-height: 118px;
  padding: 22px;
  position: relative;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.upload-dropzone:hover {
  background: #f7fbfa;
  border-color: #008e75;
}

.upload-dropzone-copy {
  align-items: center;
  display: flex;
  gap: 14px;
  height: 100%;
  min-width: 0;
  pointer-events: none;

  i {
    align-items: center;
    background: #dff6f3;
    border-radius: 8px;
    color: #008e75;
    display: inline-flex;
    flex: 0 0 42px;
    font-size: 22px;
    height: 42px;
    justify-content: center;
    width: 42px;
  }

  strong,
  span {
    display: block;
  }

  strong {
    color: #172033;
    font-size: 15px;
    font-weight: 800;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    color: #647084;
    font-size: 13px;
    margin-top: 3px;
  }
}

.upload-file-input {
  bottom: 0;
  cursor: pointer;
  height: 100%;
  left: 0;
  margin: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 2;
}

.upload-actions {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding-top: 2px;

  .custom-control {
    margin: 0;
  }

  .btn {
    align-items: center;
    display: inline-flex;
    gap: 7px;
    justify-content: center;
    min-width: 180px;
  }

  .btn:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
}

.file-name {
  color: #536074;
  font-size: 13px;
}

.excel-section {
  padding: 20px;
}

.section-title,
.excel-list-head {
  margin-bottom: 16px;

  h2 {
    color: #172033;
    font-size: 18px;
    font-weight: 800;
    margin: 0 0 4px;
  }

  p {
    color: #647084;
    margin: 0;
  }
}

.excel-form-grid {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.excel-list-card {
  overflow: hidden;
}

.excel-list-head {
  align-items: center;
  border-bottom: 1px solid #e7edf4;
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 18px 20px;
}

.excel-table-wrap {
  overflow-x: auto;
}

.excel-table {
  border-collapse: collapse;
  min-width: 1180px;
  width: 100%;

  th {
    background: #eef3fb;
    color: #354158;
    font-size: 12px;
    font-weight: 800;
    padding: 14px 18px;
    text-align: left;
    text-transform: uppercase;
  }

  td {
    border-top: 1px solid #e7edf4;
    color: #172033;
    font-size: 13px;
    padding: 16px 18px;
    vertical-align: middle;
  }

  td > strong {
    display: block;
    font-size: 15px;
    font-weight: 800;
  }

  td > span,
  td small {
    color: #647084;
    display: block;
    margin-top: 3px;
  }
}

.unit-select {
  background: #fff;
  border: 1px solid #d8dee8;
  border-radius: 5px;
  color: #172033;
  font-size: 13px;
  height: 38px;
  min-width: 82px;
  padding: 0 10px;
}

.target-select {
  min-width: 240px;
}

.target-select ::v-deep .vs__dropdown-toggle {
  border-color: #d8dee8;
  min-height: 38px;
}

.target-select ::v-deep .vs__selected,
.target-select ::v-deep .vs__search {
  color: #172033;
  font-size: 13px;
}

.area-cell {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 190px;

  strong {
    color: #008e75;
    font-size: 15px;
    font-weight: 800;
  }

  span,
  small {
    color: #647084;
    display: block;
    line-height: 1.3;
  }
}

.btn-remove-item {
  align-items: center;
  background: #fff5f5;
  border: 1px solid #ffd0d0;
  border-radius: 5px;
  color: #d63939;
  display: inline-flex;
  font-size: 16px;
  height: 36px;
  justify-content: center;
  width: 36px;
}

.btn-remove-item:hover {
  background: #ffe8e8;
  color: #b42323;
}

.excel-warnings {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;

  span {
    background: #fff4d7;
    border-radius: 999px;
    color: #8a5a00;
    display: inline-block;
    font-size: 11px;
    font-weight: 800;
    padding: 4px 9px;
  }
}

.excel-empty {
  color: #647084 !important;
  padding: 28px !important;
  text-align: center;
}

@media (max-width: 768px) {
  .excel-receita-page.bloco {
    padding: 20px;
  }

  .excel-page-actions,
  .upload-options,
  .upload-actions {
    align-items: stretch;
    flex-direction: column;
  }

  .upload-dropzone,
  .excel-form-grid {
    grid-template-columns: 1fr;
  }
}
</style>

<style lang="scss">
.vs__dropdown-menu {
  z-index: 2050;
}
</style>
